export enum ConfigurationActionTypes {
  SET_CONFIGURATION = 'SET_CONFIGURATION',

  SET_CONFIG_BAGSIZE = 'SET_CONFIG_BAGSIZE',
  SET_CONFIG_BODY = 'SET_CONFIG_BODY',
  SET_CONFIG_EDGE = 'SET_CONFIG_EDGE',
  SET_CONFIG_THREAD = 'SET_CONFIG_THREAD',
  SET_CONFIG_INSIDE = 'SET_CONFIG_INSIDE',
  SET_CONFIG_POCKET = 'SET_CONFIG_POCKET',
  SET_CONFIG_SIDE = 'SET_CONFIG_SIDE',
  SET_CONFIG_FRONT = 'SET_CONFIG_FRONT',
  SET_CONFIG_TACK = 'SET_CONFIG_TACK',
  SET_CONFIG_BACK = 'SET_CONFIG_BACK',
  SET_CONFIG_NAMECHAR = 'SET_CONFIG_NAMECHAR',
  SET_CONFIG_NAEMTHREAD = 'SET_CONFIG_NAEMTHREAD',
  SET_CONFIG_NONAME = 'SET_CONFIG_NONAME'
}
